// extracted by css-extract-rspack-plugin
export default {"progress":"CpcActions-module__progress--s_nfN"};